import { SectionTag } from "@/components/Motion";
import PageSeo from "@/components/PageSeo";
import { CGU_DATA } from "@/data/cgu";
import { CONFIDENTIALITE_DATA } from "@/data/confidentialite";
import { MENTIONS_LEGALES_DATA, REGLEMENTAIRE_DATA } from "@/data/legal";
import { hy } from "@/lib/hyphenate";

const PAGES = {
  cgu: { data: CGU_DATA, path: "/cgu", testId: "cgu-page" },
  confidentialite: { data: CONFIDENTIALITE_DATA, path: "/confidentialite", testId: "confidentialite-page" },
  "mentions-legales": { data: MENTIONS_LEGALES_DATA, path: "/mentions-legales", testId: "mentions-legales-page" },
  "informations-reglementaires": { data: REGLEMENTAIRE_DATA, path: "/informations-reglementaires", testId: "reglementaire-page" },
};

export default function LegalPage({ kind }) {
  const { data, path, testId } = PAGES[kind];
  return (
    <div data-testid={testId} className="mx-auto max-w-4xl px-5 sm:px-8 py-16 lg:py-24">
      <PageSeo path={path} />
      <SectionTag className="mb-4">{data.subtitle}</SectionTag>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold uppercase tracking-tighter leading-none mb-16">
        {hy(data.title)}
      </h1>
      <div className="space-y-12">
        {data.sections.map((s) => (
          <section key={s.h}>
            <h2 className="font-display text-lg font-bold uppercase tracking-tight border-b-2 border-ink pb-3 mb-5">
              {hy(s.h)}
            </h2>
            {s.paras &&
              s.paras.map((p) => (
                <p key={p} className="text-sm leading-relaxed text-ink/80 mb-3">
                  {p}
                </p>
              ))}
            {s.list && (
              <ol className="space-y-3">
                {s.list.map((item, j) => (
                  <li key={item} className="flex gap-4 text-sm leading-relaxed text-ink/80">
                    <span className="font-mono text-[10px] text-accent pt-1 shrink-0">
                      {String(j + 1).padStart(2, "0")}
                    </span>
                    <span>{item}</span>
                  </li>
                ))}
              </ol>
            )}
          </section>
        ))}
      </div>
    </div>
  );
}
